import "./DownloadApp.scss";
import background from "../../assets/images/Hero_Section.png";
import googlePlayIcon from "../../assets/images/Google Play Badge.png";
import appStoreIcon from "../../assets/images/App Store Badge.png";
import logo from "../../assets/images/logo.webp";
import { Link } from "react-router-dom";

const DownloadAppPage = () => {
  return (
    <div className="download-app-page">
      <div
        className="background-image"
        style={{ backgroundImage: `url(${background})` }}
      >
        <div className="download-page-content">
          <img src={logo} alt="" className="logo" />
          <div className="download-text">
            <h1 className="block-title">Download Our App</h1>
            <p className="content">
              Experience the best features and stay updated. Download our app
              now!
            </p>
          </div>
          <div className="buttons">
            <Link to="/" className="store-button">
              <img src={googlePlayIcon} alt="Google Play" />
            </Link>
            <Link to="/" className="store-button">
              <img src={appStoreIcon} alt="App Store" />
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DownloadAppPage;
